import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { CaretDownIconSmall, IconButton } from '@frontend/design-system';
import { useCompactTableRowContext } from '../../../context/compact-table-row-context';

export const CompactTableExpandRowButton = () => {
  const { t } = useTranslation();
  const { handleRowExpand, isExpanded, item } = useCompactTableRowContext();

  return (
    <IconButton
      color='light'
      size='small'
      label={isExpanded ? t('Condense row') : t('Expand row')}
      onClick={() => handleRowExpand(item, isExpanded)}
    >
      <CaretDownIconSmall
        css={css`
          transition: transform 200ms ease-out;
          transform: ${isExpanded ? `rotate(180deg)` : null};
        `}
        color='light'
        size={16}
      />
    </IconButton>
  );
};
